<template>
  <div class="login-root">
    <v-container
      fluid
      fill-height
      class="pa-0"
      :class="$vuetify.display.smAndDown ? '' : 'login-bg'"
    >
      <div class="login-overlay"></div>

      <Snackbar :SnackBarComponent="SnackBarComponent" />

      <v-layout
        align-center
        justify-center
        class="login-content"
        :class="$vuetify.display.smAndDown ? 'mt-n10' : ''"
      >
        <v-row justify="center" align="center">
          <v-col cols="12" align="center">
            <v-card
              class="login-card pa-8"
              color="white"
              max-width="450px"
              elevation="10"
            >
              <div class="text-center">
                <v-avatar
                  size="60"
                  color="#0061ac"
                  class="mb-2 shield-icon pa-1"
                >
                  <v-img src="@/assets/MIHS_logo.png" width="50px" />
                </v-avatar>
                <p class="app-title">MAKE IT HOME SAFE</p>
              </div>
              <v-window v-model="loginStepper" :touch="false" class="mt-8">
                <!-- <div class="mb-4">
                  <h2 class="login-title mt-3">Admin Login</h2>
                </div> -->

                <v-card-text class="pa-0">
                  <!-- STEP 1 -->
                  <v-window-item :value="1">
                    <v-form ref="form">
                      <label class="field-label d-block text-left mb-1"
                        >Username
                      </label>
                      <v-text-field
                        v-model="Login.email"
                        density="compact"
                        variant="outlined"
                        autocomplete="false"
                        prepend-inner-icon="mdi-account-outline"
                        :rules="emailRules"
                        required
                        placeholder="example@gmail.com"
                      />

                      <label class="field-label d-block text-left mb-1"
                        >Password</label
                      >
                      <v-text-field
                        density="compact"
                        variant="outlined"
                        v-model="Login.password"
                        :type="pass ? 'text' : 'password'"
                        :rules="passwordRules"
                        required
                        autocomplete="false"
                        prepend-inner-icon="mdi-lock-outline"
                        :append-inner-icon="
                          pass ? 'mdi-eye-off-outline' : 'mdi-eye-outline'
                        "
                        @click:append-inner="pass = !pass"
                        placeholder="******"
                      />

                      <v-row class="">
                        <v-col cols="6">
                          <v-checkbox
                            density="compact"
                            hide-details
                            label="Remember me"
                            color="blueColorVariant9"
                            v-model="rememberme"
                          />
                        </v-col>
                        <v-col cols="6" class="text-right mt-2">
                          <span class="forgot-link" @click="loginStepper = 3">
                            Forgot password?
                          </span>
                        </v-col>
                      </v-row>

                      <v-btn
                        block
                        size="large"
                        class="sign-btn mt-4"
                        :loading="loading"
                        @click="ValidateMethod()"
                      >
                        Sign In
                      </v-btn>
                    </v-form>
                  </v-window-item>

                  <v-window-item :value="2">
                    <v-card-text>
                      <v-form ref="formCP">
                        <v-text-field
                          density="compact"
                          variant="outlined"
                          label="Enter New Password *"
                          :type="isPwdNew ? 'text' : 'password'"
                          @click:append-inner="isPwdNew = !isPwdNew"
                          :append-icon="isPwdNew ? 'mdi-eye-off' : 'mdi-eye'"
                          v-model="Password.NewPassword"
                        />
                        <v-text-field
                          density="compact"
                          variant="outlined"
                          label="Confirm New Password *"
                          :type="isPwdConfirm ? 'text' : 'password'"
                          @click:append-inner="isPwdConfirm = !isPwdConfirm"
                          :append-icon="
                            isPwdConfirm ? 'mdi-eye-off' : 'mdi-eye'
                          "
                          v-model="Password.ConfirmPassword"
                        />
                        <v-btn
                          block
                          class="sign-btn mt-4"
                          @click="ValidateConfirmPasswordForm()"
                        >
                          Login
                        </v-btn>
                      </v-form>
                    </v-card-text>
                  </v-window-item>

                  <v-window-item :value="3">
                    <v-card-text>
                      <v-form ref="Forgetpass">
                        <label class="field-label d-block text-left mb-1"
                          >Email *
                        </label>
                        <v-text-field
                          density="compact"
                          variant="outlined"
                          placeholder="example@gmail.com"
                          prepend-inner-icon="mdi-account-outline"
                          v-model="OTPEmail"
                          :rules="emailRules"
                        />
                        <v-btn
                          block
                          class="sign-btn mt-4"
                          elevation="0"
                          :loading="SendCodeLoading"
                          @click="ValidateOTP()"
                        >
                          Send Code
                        </v-btn>

                        <v-card-actions justify-end class="pt-16">
                          <v-btn
                            color="blueColorVariant9"
                            size="small"
                            dark
                            variant="outlined"
                            @click="loginStepper = 1"
                          >
                            <v-icon
                              size="small"
                              color="blueColorVariant9"
                              class="mr-1"
                              >mdi-chevron-double-left</v-icon
                            >
                            Back to Sign In
                          </v-btn>
                        </v-card-actions>
                      </v-form>
                    </v-card-text>
                  </v-window-item>

                  <v-window-item :value="5">
                    <v-card-text>
                      <v-form ref="formConfirmOTP">
                        <div class="text-center">Enter the Activation Code</div>
                        <v-text-field
                          density="compact"
                          variant="outlined"
                          label="Code *"
                          v-model="ConfirmOTP"
                          :rules="[(v) => !!v || 'Code is required']"
                          class="mt-4 field_height field_label_size fontsize12px"
                        >
                        </v-text-field>
                        <v-text-field
                          density="compact"
                          variant="outlined"
                          label="Enter New Password *"
                          v-model="ConfirmNewPassword"
                          :rules="[(v) => !!v || 'Password is required']"
                          class="field_height field_label_size fontsize12px"
                          :type="isPwdConfirmCode ? 'text' : 'password'"
                          @click:append-inner="
                            isPwdConfirmCode = !isPwdConfirmCode
                          "
                          required
                          :append-inner-icon="
                            isPwdConfirmCode ? 'mdi-eye' : 'mdi-eye-off'
                          "
                          prepend-inner-icon="mdi-lock"
                        >
                        </v-text-field>
                        <v-text-field
                          density="compact"
                          variant="outlined"
                          label="Re-enter New Password *"
                          v-model="ReenterNewPassword"
                          :rules="[(v) => !!v || 'Password is required']"
                          class="field_height field_label_size fontsize12px CursorPointer"
                          :type="isPwdConfirmCode ? 'text' : 'password'"
                          @click:append-inner="
                            isPwdConfirmCode = !isPwdConfirmCode
                          "
                          required
                          :append-inner-icon="
                            isPwdConfirmCode ? 'mdi-eye' : 'mdi-eye-off'
                          "
                          prepend-inner-icon="mdi-lock"
                        >
                        </v-text-field>
                      </v-form>
                    </v-card-text>
                    <v-card-actions>
                      <v-btn
                        dark
                        color="blueColorVariant9"
                        size="small"
                        variant="elevated"
                        @click="loginStepper = 1"
                        >Back To Sign In</v-btn
                      >
                      <v-spacer />
                      <v-btn
                        dark
                        color="blueColorVariant9"
                        size="small"
                        variant="elevated"
                        @click="ValidateEnteredOTP()"
                        >Next</v-btn
                      >
                    </v-card-actions>
                  </v-window-item>
                </v-card-text>
              </v-window>
            </v-card>

            <p class="copyright">
              © 2026 Make It Home Safe. All rights reserved.
            </p>
          </v-col>
        </v-row>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { Auth } from "aws-amplify";
import {
  signIn,
  confirmSignIn,
  resetPassword,
  confirmResetPassword,
  signOut,
} from "aws-amplify/auth";
import Snackbar from "@/components/Extras/SnackBar.vue";

export default {
  components: {
    Snackbar,
  },
  data: () => ({
    pass: false,
    OTPEmail: "",
    ConfirmOTP: "",
    loginStepper: 1,
    Password: {
      NewPassword: "",
      ConfirmPassword: "",
    },
    isPwdConfirmCode: false,
    ConfirmNewPassword: "",
    ReenterNewPassword: "",
    loading: false,
    isPwdConfirm: false,
    rememberme: false,
    isPwdNew: false,
    valid: true,
    SendCodeLoading: false,
    isPwd: false,
    Login: {
      email: "",
      password: "",
    },
    password: "",
    windowHeight: 0,
    passwordRules: [
      (v) => !!v || "",
      (v) =>
        (v && v.length <= 10) || "password must be less than 10 characters",
    ],
    email: "",
    emailRules: [
      (v) => !!v || "",
      (v) => /.+@.+\..+/.test(v) || "Email must be valid",
    ],
    SnackBarComponent: {},
  }),
  watch: {
    rememberme(val) {
      if (val == true) {
        localStorage.setItem("currentuseremail", JSON.stringify(this.Login));
      } else if (val == false) {
        delete localStorage.currentuseremail;
      }
    },
  },
  computed: {
    currentTitle() {
      switch (this.loginStepper) {
        case 1:
          return "Welcome!";
        case 2:
          return "Change Temporary Password";
        case 3:
          return "Forgot Password ?";
        case 4:
          return "Enter Code Sent to Email";
        case 5:
          return "Validate OTP";
        default:
          return "Log In";
      }
    },
  },
  mounted() {
    this.CheckRememberMe();
    this.windowHeight = window.innerHeight;
  },
  methods: {
    CheckRememberMe() {
      if (localStorage.getItem("currentuseremail") != null) {
        this.Login = JSON.parse(localStorage.getItem("currentuseremail"));
        this.rememberme = true;
      }
    },
    async ValidateOTP() {
      const valid = await this.$refs.Forgetpass.validate();
      if (valid.valid) {
        this.SendOTPEmail();
      } else {
        this.loading = false;
        this.SnackBarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "red",
          Top: true,
          SnackbarText: "Email is required",
        };
      }
    },
    SendOTPEmail() {
      this.SendCodeLoading = true;
      resetPassword({ username: this.OTPEmail })
        .then(() => {
          this.SnackBarComponent = {
            SnackbarVmodel: true,
            SnackbarColor: "#ffd700",
            Top: true,
            SnackbarText: "OTP Sent To Registered Email",
          };
          this.loginStepper = 5;
          this.SendCodeLoading = false;
        })
        .catch((err) => {
          this.SendCodeLoading = false;
          this.SnackBarComponent = {
            SnackbarVmodel: true,
            SnackbarColor: "red",
            Top: true,
            SnackbarText: err.message,
          };
        });
    },
    // ValidateEnteredOTP() {
    //   if (this.$refs.formConfirmOTP.validate()) {
    //     if (this.ReenterNewPassword == this.ConfirmNewPassword) {
    //       this.ConfirmOTPMethod();
    //     } else {
    //       this.SnackBarComponent = {
    //         SnackbarVmodel: true,
    //         SnackbarColor: "red",
    //         Top: true,
    //         SnackbarText: "Password Does not match",
    //       };
    //     }
    //   } else {
    //     this.SnackBarComponent = {
    //       SnackbarVmodel: true,
    //       SnackbarColor: "red",
    //       Top: true,
    //       SnackbarText: "Please Enter The Code Sent To Registered Email",
    //     };
    //   }
    // },

    async ValidateEnteredOTP() {
      (this.OTPEmail = this.OTPEmail.trim()),
        (this.ConfirmOTP = this.ConfirmOTP.trim()),
        (this.ConfirmNewPassword = this.ConfirmNewPassword.trim());
      const FormValidate = await this.$refs.formConfirmOTP.validate();
      if (FormValidate.valid) {
        this.ConfirmOTPMethod();
      } else {
        this.SnackBarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "red",
          Top: true,
          SnackbarText: "Please Enter The Code Sent To Registered Email",
          timeout: 2000,
        };
      }
    },
    ConfirmOTPMethod() {
      confirmResetPassword({
        username: this.OTPEmail,
        confirmationCode: this.ConfirmOTP,
        newPassword: this.ConfirmNewPassword,
      })
        .then(() => {
          this.SnackBarComponent = {
            SnackbarVmodel: true,
            SnackbarColor: "green",
            Top: true,
            SnackbarText:
              "Password Reset Successful, Please Login with New Password",
          };
          this.loginStepper = 1;
        })
        .catch((err) => {
          this.SnackBarComponent = {
            SnackbarVmodel: true,
            SnackbarColor: "red",
            Top: true,
            SnackbarText: err.message,
          };
        });
    },

    async ValidateMethod() {
      const valid = await this.$refs.form.validate();
      if (valid.valid) {
        this.signInMethod();
      } else {
        this.SnackBarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "red",
          Top: true,
          SnackbarText: "Email and password required",
        };
      }
    },
    async signInMethod() {
      try {
        this.loading = true;
        const { isSignedIn, nextStep } = await signIn({
          username: this.Login.email.trim(),
          password: this.Login.password.trim(),
        });
        console.log("Check.....!", isSignedIn, nextStep);
        if (isSignedIn) {
          this.$store.commit("SET_USEREMAIL", this.Login.email);
          this.ActivateMethod();
        }
        if (
          nextStep?.signInStep === "CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED"
        ) {
          this.loading = false;
          this.SnackBarComponent = {
            SnackbarVmodel: true,
            SnackbarColor: "orange",
            SnackbarText: "Please set a new password",
            timeout: 2000,
          };

          this.loginStepper = 2;
          return;
        }
        this.loading = false;
      } catch (error) {
        console.log("error signing in", error);
        if (error.message == "Incorrect username or password.") {
          this.loading = false;
          this.SnackBarComponent = {
            SnackbarVmodel: true,
            SnackbarColor: "red",
            SnackbarText: error.message,
            timeout: 2000,
          };
        }
        if (error.message == "There is already a signed in user.") {
          await signOut({ global: true });
          this.signInMethod();
        }
      }
    },

    ActivateMethod() {
      this.SnackBarComponent = {
        SnackbarVmodel: true,
        SnackbarColor: "green",
        Top: true,
        SnackbarText: "Login Successful",
      };
      setTimeout(() => this.$router.push("/Dashboard"), 1000);
    },
    async ValidateConfirmPasswordForm() {
      const valid = await this.$refs.formCP.validate();
      if (valid.valid) {
        if (this.Password.NewPassword == this.Password.ConfirmPassword) {
          this.ConfirmPassword();
        } else {
          this.$refs.form.reset();
          this.SnackBarComponent = {
            SnackbarVmodel: true,
            SnackbarColor: "red",
            Top: true,
            SnackbarText: "Password does not match",
          };
        }
      } else {
        this.SnackBarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "red",
          Top: true,
          SnackbarText: "Fields marked with asterisks (*) are mandatory",
        };
      }
    },
    async ConfirmPassword() {
      try {
        this.loading = true;
        const result = await confirmSignIn({
          challengeResponse: this.Password.NewPassword.trim(),
        })
          .then((user) => {
            return user;
          })
          .catch((e) => {
            this.SnackBarComponent = {
              SnackbarVmodel: true,
              SnackbarColor: "red",
              Top: true,
              SnackbarText: e,
            };
            return e;
          });
        if (result.username) {
          this.loading = false;
          this.SnackBarComponent = {
            SnackbarVmodel: true,
            SnackbarColor: "green",
            Top: true,
            SnackbarText: "Login Successful",
          };
          this.$refs.formCP.reset();
          this.ActivateMethod();
        }
        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.SnackBarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "red",
          Top: true,
          SnackbarText: error.message,
        };
      }
    },
  },
};
</script>
<style scoped>
.login-root {
  height: 100vh;
  overflow: hidden;
}

.login-bg {
  height: 100vh;
  background: url("@/assets/policeImage.webp") center center / cover no-repeat;
  position: relative;
  overflow: hidden;
}

.login-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    to right,
    rgba(70, 90, 180, 0.6),
    rgba(10, 20, 40, 0.85)
  );
  z-index: 0;
}

.login-content {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}
.app-title {
  font-size: 22px;
  font-weight: 600;
  color: #1f3a68;
  letter-spacing: 0.6px;
}

.app-subtitle {
  color: #c7d2fe;
  font-size: 14px;
}

.shield-icon {
  background: #3f51b5;
}

.login-card {
  border-radius: 18px;
}

.login-title {
  color: rgb(72, 69, 69);
  font-size: 20px;
  font-weight: 600;
}

.login-subtitle {
  font-size: 13px;
  color: #6b7280;
}

.field-label {
  font-size: 13px;
  font-weight: 500;
  color: #374151;
}

.sign-btn {
  background: #3f51b5 !important;
  color: white !important;
  font-weight: 600;
  border-radius: 8px;
}

.forgot-link {
  font-size: 13px;
  color: #3f51b5;
  cursor: pointer;
}

.demo-box {
  font-size: 13px;
  background: #f8fafc;
  padding: 10px;
  border-radius: 8px;
}

.footer-text {
  font-size: 11px;
  color: #6b7280;
  text-align: center;
  margin-top: 8px;
}

.copyright {
  text-align: center;
  font-size: 11px;
  color: #cbd5f5;
  margin-top: 14px;
}
</style>
